export const countFoldersRecursively = (folderTree) => {
  let count = 0;

  const countInNode = (node) => {
    count += 1;

    if (node.children && Array.isArray(node.children)) {
      node.children.forEach((child) => countInNode(child));
    }
  };

  if (folderTree?.root && Array.isArray(folderTree.root)) {
    folderTree.root.forEach((rootNode) => {
      countInNode(rootNode);
    });
  }

  return count;
};
